import defer from 'lodash/defer';

import {
  initObserveStore, observeStore, utils,
} from '@resy/ui-kitchen';
import getConnectedActions from '../../modules/actions/connectedActions';

import {
  affiliatedRestaurantsTransform,
  recommendedVenuesTransform,
  venueTransform,
} from '../../../../ui-kitchen/src/api/resyApiTransformer';
import {
  getChefLists,
  getEventsUpcoming,
  getNotify,
  getVenueRecommendations,
  getVenue,
  getGoogleStaticMapUrlSign,
  getVenuesV3,
  postNotify,
} from '../../../../ui-kitchen/src/api/api';
import { getResyLocationsThunk, resetLocationThunk, setSelectedLocationThunk } from '../../../../ui-kitchen/src/reducers/resyLocationsSlice';
import {
  getSelectedCoreISODateThunk, getSelectedCoreSeatsMinMaxThunk, getSelectedCoreSeatsThunk, getSelectedCoreTimeThunk, resetSelectedCoreSeatsMinMax, setSelectedCoreISODate, setSelectedCoreSeatsMinMax, setSelectedCoreTime,
} from '../../../../ui-kitchen/src/reducers/resyCoreSlice';
import { ALL_DAY, ISO_DATE_FORMAT } from '../../../../ui-kitchen/src/constants/resyCore';
import { selectIsAuthenticated } from '../../../../ui-kitchen/src/reducers/authTokenSlice';
import {
  getUserThunk, userLogoutThunk, selectIsCenturionEligible, selectIsPlatinumEligible, selectIsPlatinumNight,
} from '../../../../ui-kitchen/src/reducers/userSlice';
import {
  US_OPEN_CENTURION_EXCLUSIVE_ID,
  US_OPEN_PLATINUM_EXCLUSIVE_ID,
} from '../../../../ui-kitchen/src/constants/exclusiveIds';
import { getURLSearchParams, setSearchParams } from '../../../../ui-kitchen/src/utils/searchParamUtils';
import Logger from '../../../../ui-kitchen/src/utils/logger';
import { getTranslation } from '../../../../ui-kitchen/src/providers/TranslationProvider';
import { sanitizeString } from '../../../../ui-kitchen/src/utils/sanitizeString';
import { isUSOpenVenueId } from '../../../../ui-kitchen/src/utils/isUSOpenVenue';
import getNomaVenueID from '../../../../ui-kitchen/src/utils/getNomaVenueID';
import normalizeUSOpenExclusiveEligibilityHelper from './utils/usOpenExclusiveEligibility';

/* eslint-disable no-multi-assign, no-param-reassign, no-unused-vars */

(() => {
  angular
    .module('resyApp')
    .controller('VenueDetailsCtrl', VenueDetailsCtrl);

  function VenueDetailsCtrl(
    $exceptionHandler,
    $location,
    $ngRedux,
    $q,
    $rootScope,
    $routeParams,
    $scope,
    $window,
    CalendarStateDeterminer
  ) {
    const thisCtrl = this;
    const store = $rootScope.reduxStore;
    const { dispatch, getState } = store;
    const {
      updateVenueBlogThunk, getVenueInventoryThunk, getVenueReservationsThunk, getResyConfigVenueThunk,
    } = getConnectedActions(dispatch);

    const locationSlug = $routeParams.location;
    const { checkIfType } = utils;
    let restaurantSchema;
    let isInLocationList;
    let lastAvailableDate = null;
    let hasLoadedInitialVenue = false;

    thisCtrl.is404 = false;
    thisCtrl.activeMonth = null;
    thisCtrl.activeNotifications = {};
    thisCtrl.affiliatedRestaurants = [];
    thisCtrl.calendar = null;
    thisCtrl.clearTimeFilter = clearTimeFilter;
    thisCtrl.containerQuery = $rootScope.matchMedia;
    thisCtrl.customAffiliation = null;
    thisCtrl.customAffiliations = [];
    thisCtrl.isLargePartyConfigured = false;
    thisCtrl.isVenueClosed = false;
    thisCtrl.largePartyMessage = null;
    thisCtrl.loadReservations = null;
    thisCtrl.loadingReservations = true;
    thisCtrl.maxQuantity = null;
    thisCtrl.minQuantity = null;
    thisCtrl.notifyForUnavailable = null;
    thisCtrl.onCloseVenueGroupModal = onCloseVenueGroupModal;
    thisCtrl.onCloseChefsListModal = onCloseChefsListModal;
    thisCtrl.onTimeChange = onTimeChange;
    thisCtrl.openModal = resyWidget.openModal;
    thisCtrl.partnershipBranding = null;
    thisCtrl.quantitySuffix = null;
    thisCtrl.reservations = [];
    thisCtrl.selectedDate = null;
    thisCtrl.selectedQuantity = null;
    thisCtrl.selectedTime = null;
    thisCtrl.serviceTypeId = undefined;
    thisCtrl.showAuthModal = showAuthModal;
    thisCtrl.store = $ngRedux;
    thisCtrl.upcomingEvents = [];
    thisCtrl.venue = {};
    thisCtrl.venueInventory = {};
    thisCtrl.venueInventoryCache = {};
    thisCtrl.venueGroup = null;
    thisCtrl.venueGroups = null;

    const { venueInventoryUtils } = utils;
    const globalWidgetConfig = {};

    const searchParams = getURLSearchParams();
    if (searchParams.get('request_start')) {
      const notifyDate = searchParams.get('request_start');
      const formattedNotifyDate = moment(notifyDate).format(ISO_DATE_FORMAT);
      dispatch(setSelectedCoreISODate(formattedNotifyDate));
    }

    function normalizeUSOpenExclusiveEligibility(reservations = []) {
      if (!isUSOpenVenueId(thisCtrl.venue?.id)) {
        return reservations;
      }

      const isCenturionEligible = selectIsCenturionEligible(getState());
      const isPlatinumEligible = selectIsPlatinumEligible(getState());

      return normalizeUSOpenExclusiveEligibilityHelper({
        reservations,
        isCenturionEligible,
        isPlatinumEligible,
        centurionExclusiveId: US_OPEN_CENTURION_EXCLUSIVE_ID,
        platinumExclusiveId: US_OPEN_PLATINUM_EXCLUSIVE_ID,
      });
    }

    function shouldLoadVenueBookingData(venue = thisCtrl.venue) {
      const isUSOpenVenue = isUSOpenVenueId(venue?.id);
      if (!isUSOpenVenue) {
        return true;
      }

      const isUSOpenEligible = selectIsAuthenticated(getState())
        && (selectIsCenturionEligible(getState()) || selectIsPlatinumEligible(getState()));

      return isUSOpenEligible;
    }

    const onBlogSliceChange = (blogState) => {
      thisCtrl.blogContent = blogState.blogContent;
      defer(() => $scope.$apply());
    };
    const unsubscribeBlog = observeStore(
      store,
      ({ blog }) => (blog),
      onBlogSliceChange
    );

    const onAuthSliceChange = () => {
      // Wait for refresh-token bootstrap before loading venue data
      if (getState().authToken.isLoading) {
        return;
      }

      if (selectIsAuthenticated(getState())) {
        dispatch(getUserThunk())
          .then((data) => {
            thisCtrl.userIsGda = data.is_global_dining_access;
            thisCtrl.userIsCenturionEligible = data.is_centurion_eligible;
            thisCtrl.userIsPlatinumEligible = data.is_platinum_eligible;
          })
          .catch((err) => Logger.error('[ERROR] venueDetails getUserThunk (onAuthSliceChange): ', err))
          .finally(() => {
            if (!hasLoadedInitialVenue) {
              hasLoadedInitialVenue = true;
              loadVenue();
            }
          });
      } else if (!hasLoadedInitialVenue) {
        hasLoadedInitialVenue = true;
        loadVenue();
      }
    };
    const unsubscribeAuth = observeStore(
      store,
      ({ authToken }) => (authToken),
      onAuthSliceChange
    );

    const onVenueInventorySliceChange = (venueInventorySlice) => {
      assessVenueInventory(venueInventorySlice.venueInventory);
      thisCtrl.venueInventoryCache = venueInventorySlice.cache;
      defer(() => $scope.$apply());
    };
    const unsubscribeVenueInventory = observeStore(
      store,
      ({ venueInventory }) => (venueInventory),
      onVenueInventorySliceChange
    );

    const onVenueReservationsSliceChange = (venueReservationsSlice) => {
      if (venueReservationsSlice.status === 'pending') {
        thisCtrl.loadingReservations = true;
      }
      if (venueReservationsSlice.status === 'success') {
        const { data } = venueReservationsSlice;
        const queryParams = $location.search();
        const isUSOpenVenue = isUSOpenVenueId(thisCtrl.venue?.id);
        const isUSOpenEligible = selectIsAuthenticated(getState())
          && (selectIsCenturionEligible(getState()) || selectIsPlatinumEligible(getState()));
        thisCtrl.loadingReservations = false;
        thisCtrl.activeNotifications = (isUSOpenVenue && !isUSOpenEligible) ? {} : data.activeNotifications;
        thisCtrl.notifyForUnavailable = (isUSOpenVenue && !isUSOpenEligible) ? [] : data.notifyForUnavailable;
        thisCtrl.partnershipBranding = data.partnershipBranding;
        thisCtrl.reservations = normalizeUSOpenExclusiveEligibility(data.reservations);
        thisCtrl.platinumNight = data.platinumNight;
        thisCtrl.doubleBookingError = data.error;
        thisCtrl.filterQuery = data.query;

        utils.assessNotifyParams($location, openNotify);
        assessReservations(thisCtrl.reservations);
        const notifyValues = {
          queryParams,
          reservationsByServicePeriod: thisCtrl.reservations,
          selectResy,
          setNotifyData,
        };

        if (queryParams.tableConfigId) {
          utils.assessTableConfigId(notifyValues);
        } else {
          utils.assessTimeslot(notifyValues);
        }

        if (queryParams.request_start) {
          setSearchParams('timeslot', null);
          setSearchParams('request_start', null);
          setSearchParams('request_end', null);
          setSearchParams('notify_request_id', null);
        }
      }
      defer(() => $scope.$apply());
    };
    const observeVenueReservationsSlice = initObserveStore(store, ({ venueReservations }) => (venueReservations));
    const unsubscribeVenueReservationsSlice = observeVenueReservationsSlice(onVenueReservationsSliceChange);

    const onFavoriteStoreChange = (favorite) => {
      thisCtrl.isFavorite = favorite?.venueIds?.includes(thisCtrl.venue.id);
      defer(() => $scope.$apply());
    };
    const unsubscribeFavorite = observeStore(
      store,
      ({ favorite }) => (favorite),
      onFavoriteStoreChange
    );

    const onResyCoreSliceChange = (resyCoreSlice) => {
      const {
        selectedCoreISODate, selectedCoreSeats, selectedCoreSeatsMax, selectedCoreSeatsMin, selectedCoreTime,
      } = resyCoreSlice;

      // SELECTED_TIME_UPDATED handling
      if (thisCtrl.selectedTime !== selectedCoreTime) {
        resetReservationsData();
        thisCtrl.selectedTime = selectedCoreTime;
        if ($rootScope.searchProps) {
          $rootScope.searchProps.selectedTime = selectedCoreTime;
        }

        if (shouldLoadVenueBookingData()) {
          loadVenueInventory(thisCtrl.venue.id, thisCtrl.selectedQuantity);
          loadReservations(thisCtrl.venue.id, thisCtrl.selectedDate, thisCtrl.selectedQuantity);
        }
      }

      // SELECTED_DATE_UPDATED handling
      // thisCtrl.selectedDate is a Date object.
      // Convert thisCtrl.selectedDate to ISO format to compare to selectedCoreISODate,
      // then convert back to Date object when assigning.
      const thisSelectedISODate = thisCtrl.selectedDate instanceof Date
        ? moment(thisCtrl.selectedDate).format(ISO_DATE_FORMAT)
        : thisCtrl.selectedDate;
      if (thisSelectedISODate !== selectedCoreISODate && selectedCoreISODate !== null) {
        const selectedDate = moment(selectedCoreISODate, ISO_DATE_FORMAT).toDate();
        resetReservationsData();
        thisCtrl.selectedDate = selectedDate;
        thisCtrl.selectedDateFormatted = globalWidgetConfig.date = moment(thisCtrl.selectedDate).calendar();
        loadAffiliatedVenues();

        const shouldFetch = moment(lastAvailableDate).isSameOrAfter(selectedCoreISODate) && thisCtrl.venue.id;
        if (shouldFetch && shouldLoadVenueBookingData()) {
          loadVenueInventory(thisCtrl.venue.id, thisCtrl.selectedQuantity);
          loadReservations(thisCtrl.venue.id, thisCtrl.selectedDate, thisCtrl.selectedQuantity);
        }
      }

      // PARTY_SIZE_SELECTED_UPDATED handler
      if (thisCtrl.selectedQuantity !== selectedCoreSeats) {
        resetReservationsData();
        thisCtrl.selectedQuantity = globalWidgetConfig.seats = selectedCoreSeats;
        loadAffiliatedVenues();

        /**
         * Reset activeMonth to selectedDate
         * The intended effect is that if the calendar had been paged into the future,
         * it will be reset (visually) to whatever was selected
        */
        thisCtrl.activeMonth = moment(thisCtrl.selectedDate);

        const shouldFetch = !checkIfType.isNull(thisCtrl.selectedDate)
          && (!lastAvailableDate || moment(lastAvailableDate).isSameOrAfter(thisCtrl.selectedDate))
          && thisCtrl.venue.id;
        if (shouldFetch && shouldLoadVenueBookingData()) {
          loadVenueInventory(thisCtrl.venue.id, thisCtrl.selectedQuantity);
          loadReservations(thisCtrl.venue.id, thisCtrl.selectedDate, thisCtrl.selectedQuantity);
        }
      }
      // PARTY_SIZE_MIN_MAX_UPDATED handler
      if (thisCtrl.maxQuantity !== selectedCoreSeatsMax) {
        thisCtrl.maxQuantity = selectedCoreSeatsMax;
      }
      if (thisCtrl.minQuantity !== selectedCoreSeatsMin) {
        thisCtrl.minQuantity = selectedCoreSeatsMin;
      }
      defer(() => $scope.$apply());
    };

    const observeResyCoreSlice = initObserveStore(store, ({ resyCore }) => (resyCore));
    const unsubscribeResyCoreSlice = observeResyCoreSlice(onResyCoreSliceChange);

    $scope.$on('$destroy', () => {
      unsubscribeBlog();
      unsubscribeAuth();
      unsubscribeFavorite();
      unsubscribeResyCoreSlice();
      unsubscribeVenueInventory();
      unsubscribeVenueReservationsSlice();
    });

    thisCtrl.notifyData = {
      shouldShowTimeslotNotFound: false,
      date: null,
      time: null,
    };

    if (selectIsAuthenticated(getState())) {
      dispatch(getUserThunk())
        .then((data) => {
          thisCtrl.userIsGda = data.is_global_dining_access;
          thisCtrl.userIsPlatinumNight = data.is_platinum_night_eligible;
          thisCtrl.userIsCenturionEligible = data.is_centurion_eligible;
          thisCtrl.userIsPlatinumEligible = data.is_platinum_eligible;
          defer(() => $scope.$apply());
        })
        .catch((err) => Logger.error('[ERROR] venueDetails getUserThunk: ', err));
    }

    thisCtrl.selectResy = selectResy;

    onInit();

    function onInit() {
      setupReactors();
      loadLocations();
      // Load date, time, & partySize before loading venue
      $q
        .all([
          loadDate(),
          loadPartySize(),
          loadTime(),
        ])
        .then(() => onAuthSliceChange());
    }

    function fetchRecommendedVenues(config) {
      return getVenueRecommendations({
        venueId: thisCtrl.venue.id,
        date: moment(thisCtrl.selectedDate).format('YYYY-MM-DD'),
        party_size: thisCtrl.selectedQuantity,
        location_slug: thisCtrl.venue.location.url_slug,
        time_range_start: config.time,
        time_range_end: config.endTime,
        limit: 10,
      });
    }

    async function setNotifyData(config) {
      const notifyData = config;
      const notifyNotFound = config.shouldShowTimeslotNotFound || config.shouldShowTableConfigIdNotFound;
      if (notifyNotFound && thisCtrl.venue?.showRecommendations) {
        const recommendedVenues = await fetchRecommendedVenues(config);
        if (recommendedVenues.results?.length > 0) {
          notifyData.shouldShowTimeslotNotFound = false;
          notifyData.shouldShowTableConfigIdNotFound = false;
          notifyData.shouldShowRecommendations = true;
          thisCtrl.recommendedVenues = recommendedVenuesTransform(recommendedVenues.results);
        }
      }

      thisCtrl.notifyData = notifyData;
    }

    function selectResy(config, reservation, elementToReturnFocusTo) {
      if ('notifyService' in config) {
        openNotify(config.notifyService);
      } else {
        resyWidget.openModal(
          {
            ...globalWidgetConfig,
            ...config,
          },
          {
            venueName: thisCtrl.venue.name,
            ...reservation,
          },
          elementToReturnFocusTo
        );
      }
    }

    function onCloseNotifyModal() {
      thisCtrl.notifyIsOpen = false;
    }

    thisCtrl.onCloseNotifyModal = onCloseNotifyModal;

    function openNotify(serviceId = false) {
      const callback = () => {
        thisCtrl.serviceTypeId = parseInt(serviceId, 10);
        $scope.$broadcast('TOGGLE_MODAL', serviceId);
      };

      if (selectIsAuthenticated(getState())) {
        // BEGIN angular digest wildness to avoid issues with digest already in progress
        if (!$rootScope.$$phase) {
          $scope.$apply(
            callback
          );
        } else {
          try {
            setTimeout(callback, 50);
          } catch (error) {
            $exceptionHandler(error);
          }
        }
        // END angular digest wildness
      } else {
        showAuthModal(() => {
          $location.search('notifyService', String(serviceId));
        });
      }
    }

    thisCtrl.openNotify = openNotify;

    function setupReactors() {
      $scope.$on('$routeChangeStart', () => {
        dispatch(resetSelectedCoreSeatsMinMax());

        if (!isInLocationList) {
          dispatch(resetLocationThunk({ $rootScope, $window }));
        }
      });
    }

    function loadLocations() {
      dispatch(getResyLocationsThunk()).then((locations) => {
        assessLocation(locations);
      });
    }

    function assessLocation(locations) {
      const foundLocation = locations.find((location) => location && location.url_slug === locationSlug);
      isInLocationList = !!foundLocation;
      const params = {
        $rootScope,
        $window,
      };
      params.location = isInLocationList ? foundLocation : {
        urlSlug: locationSlug,
        name: null,
        hideMenu: true,
      };
      dispatch(setSelectedLocationThunk(params));
    }

    function assessReservations(reservations) {
      thisCtrl.hasAvailability = reservations.some((resy) => resy.available.length > 0);
    }

    function loadDate() {
      const deferred = $q.defer();
      const selectedCoreISODate = dispatch(getSelectedCoreISODateThunk());

      thisCtrl.selectedDate = moment(selectedCoreISODate, ISO_DATE_FORMAT).toDate();
      thisCtrl.selectedDateFormatted = moment(thisCtrl.selectedDate).calendar();
      defer(() => $scope.$apply());
      deferred.resolve();
      return deferred.promise;
    }

    function loadPartySize() {
      const deferred = $q.defer();
      thisCtrl.selectedQuantity = dispatch(getSelectedCoreSeatsThunk());
      const { min, max } = dispatch(getSelectedCoreSeatsMinMaxThunk());
      thisCtrl.minQuantity = min;
      thisCtrl.maxQuantity = max;
      defer(() => $scope.$apply());
      deferred.resolve();
      return deferred.promise;
    }

    function loadTime() {
      const selectedTime = dispatch(getSelectedCoreTimeThunk());
      thisCtrl.selectedTime = selectedTime;
      defer(() => $scope.$apply());
    }

    async function loadVenue() {
      let venue;
      getVenue({ url_slug: $routeParams.venueSlug, location: locationSlug })
        .then((response) => {
          venue = venueTransform(response);
          if (!venue || !venue.id) {
            throw new Error('Transform failure');
          }
          thisCtrl.venue = venue;
          thisCtrl.venueGroup = venue.venueGroup;
          thisCtrl.isFavorite = venue.favorite;

          defer(() => $scope.$apply());
        })
        .then(() => {
          buildPageTitle(venue.name);
          loadResyConfig(venue.id);
          const isNomaVenue = venue?.id === getNomaVenueID();
          const isPlatinumNightEligible = selectIsAuthenticated(getState())
            && selectIsPlatinumNight(getState());

          if (!(isNomaVenue && !isPlatinumNightEligible) && shouldLoadVenueBookingData(venue)) {
            const selectedQuantity = thisCtrl.selectedQuantity > venue?.minPartySize ? thisCtrl.selectedQuantity : venue?.minPartySize;
            loadVenueInventory(venue.id, selectedQuantity, true);
            loadReservations(venue.id, thisCtrl.selectedDate, selectedQuantity);
          } else {
            thisCtrl.loadingReservations = false;
            thisCtrl.reservations = [];
            thisCtrl.activeNotifications = {};
            thisCtrl.notifyForUnavailable = [];
          }

          thisCtrl.customAffiliation = (venue.customAffiliation)
            ? venue.customAffiliation.id : null;
          thisCtrl.customAffiliations = (thisCtrl.customAffiliation)
            ? venue.customAffiliations.reduce(
              (result, item) => {
                const venues = (item.id === thisCtrl.customAffiliation)
                  ? [...result, ...item.venues]
                  : [...result];
                return venues;
              }, []
            ) : thisCtrl.venueGroup?.venues;

          thisCtrl.venue.images = processImages(thisCtrl.venue.responsiveImages, thisCtrl.venue.images);

          thisCtrl.aboutVenue = thisCtrl.venue.content.find((item) => item.name === 'about');
          thisCtrl.whyWeLikeIt = thisCtrl.venue.content.find((item) => item.name === 'why_we_like_it');
          thisCtrl.needToKnow = thisCtrl.venue.content.find((item) => item.name === 'need_to_know');

          thisCtrl.priceRange = buildPrice(venue.priceRange, venue.currency);

          $scope.metadata.description = thisCtrl.aboutVenue.body;

          if (Array.isArray(venue.images) && venue.images.length > 0) {
            $scope.metadata.image = venue.images[0].url;
            $scope.metadata.image_twitter = venue.images[0].url;
            $scope.metadata.image_facebook = venue.images[0].url;
          }

          if (venue?.enableDiscovery === 0) {
            $scope.metadata.robots = 'noindex';
          }

          $scope.metadata.appDeepLink = isUSOpenVenueId(venue?.id) ? null : $location.absUrl();
          $scope.metadata.canonical = `https://resy.com/cities/${venue.location.urlSlug}/venues/${venue.urlSlug}`;

          loadMapImage();
          loadVenueBlogContent(venue.id);

          if (!isNomaVenue || isPlatinumNightEligible) {
            fetchUpcomingEvents(venue.id);
          }

          buildRestaurantSchema();
          buildWidgetConfig();

          if (!isNomaVenue || isPlatinumNightEligible) {
            loadAffiliatedVenues();
            fetchChefLists();
          }
          defer(() => $scope.$apply());
        })
        .catch((error) => {
          Logger.error('[VenuePage] loadVenue() failure: ', error);
          /* istanbul ignore else */
          if (error?.status === 419) {
            dispatch(userLogoutThunk());
          }
          /* istanbul ignore else */
          if (error?.status === 404) {
            thisCtrl.is404 = true;
            $rootScope.prerender.responseCode = '404';
          }
          defer(() => $scope.$apply());
        });
    }

    async function fetchChefLists() {
      if (!selectIsAuthenticated(getState())) {
        return;
      }

      const oneMonthAgo = moment().subtract(1, 'month').format('YYYY-MM-DD');
      const pastNotifies = await getNotify({ filter_date: oneMonthAgo });
      const missedNotify = pastNotifies.notify?.find((notify) => notify.specs.venue_id === thisCtrl.venue.id && !!notify.has_active_chef_list && !notify.modal_dismissed);
      if (missedNotify) {
        thisCtrl.missedNotify = missedNotify;
        let lists;
        try {
          lists = await getChefLists(thisCtrl.venue.id);
        } catch (e) {
          thisCtrl.chefLists = undefined;
        }

        if (lists) {
          // temporary hardcoded chef photos until they can be uploaded in Blue Admin
          const RYAN_POLLNOW_LIST_ID = '144F229C-C091-11EE-BA4B-0EA9BE09D557';
          const HEENA_PATEL_LIST_ID = '4dfdbc30-0400-11ef-9c0a-0231543bf135';
          if (lists.list.url_slug === RYAN_POLLNOW_LIST_ID) {
            lists.created_by.profile_image_url = 'https://s3.amazonaws.com/resy.com/images/lists/ryan-pollnow.jpeg';
          } else if (lists.list.url_slug === HEENA_PATEL_LIST_ID) {
            lists.created_by.profile_image_url = 'https://s3.amazonaws.com/resy.com/images/lists/heena-patel.jpg';
          }

          thisCtrl.chefLists = lists;
        } else {
          thisCtrl.chefLists = undefined;
        }
      }
    }

    function dismissNotify() {
      const { specs } = thisCtrl.missedNotify;

      postNotify({
        struct_data: {
          notifies: [{
            venue_id: specs.venue_id,
            day: specs.day,
            time_preferred_start: specs.time_preferred_start,
            time_preferred_end: specs.time_preferred_end,
            num_seats: specs.party_size,
            service_type_id: specs.service_type_id,
            modal_dismissed: true,
          }],
        },
      });
    }

    function onCloseChefsListModal() {
      thisCtrl.chefLists = undefined;

      dismissNotify();

      defer(() => $scope.$apply());
    }

    async function loadAffiliatedVenues() {
      const oneMonthAgo = moment().subtract(1, 'month').format('YYYY-MM-DD');
      if (!thisCtrl.customAffiliations || thisCtrl.customAffiliations?.length === 0) return;

      const response = await getVenuesV3({
        lat: thisCtrl.venue.location?.coords?.lat,
        location: thisCtrl.venue.location?.code,
        long: thisCtrl.venue.location?.coords?.long,
        venue_ids: thisCtrl.customAffiliations?.join(','),
      });

      const venues = affiliatedRestaurantsTransform(response);

      thisCtrl.affiliatedRestaurants = venues
        .filter((venue) => venue?.location?.code === thisCtrl.venue?.location?.code)
        .slice(0, 3);

      if (selectIsAuthenticated(getState())) {
        const pastNotifies = await getNotify({ filter_date: oneMonthAgo });

        const doesChefListExistForMissedNotifys = pastNotifies.notify?.find((notify) => notify.specs.venue_id === thisCtrl.venue.id && !!notify.has_active_chef_list && !notify.modal_dismissed);

        if (!doesChefListExistForMissedNotifys) {
          const missedNotify = pastNotifies.notify?.find((notify) => notify.specs.venue_id === thisCtrl.venue.id && !notify.modal_dismissed && !!notify.show_venue_group_recommendations);

          thisCtrl.missedNotify = missedNotify;
          if (missedNotify) {
            thisCtrl.venueGroups = venues.filter((venue) => venue?.location?.code === thisCtrl.venue?.location?.code);
          }
        }
      }

      defer(() => $scope.$apply());
    }

    function onCloseVenueGroupModal() {
      thisCtrl.venueGroups = undefined;

      dismissNotify();

      defer(() => $scope.$apply());
    }

    function loadMapImage() {
      const size = '620x200';

      const mapUrl = `https://maps.googleapis.com/maps/api/staticmap?size=${size}&zoom=15&markers=size:large%7Ccolor:0xE5382E%7C${thisCtrl.venue.location.coords.lat},${thisCtrl.venue.location.coords.long}&key=[REDACTED_GCP_API_KEY_1]`; // eslint-disable-line

      getGoogleStaticMapUrlSign({ url: mapUrl })
        .then(({ url }) => {
          thisCtrl.venue.googleMapImageUrl = url;
          defer(() => $scope.$apply());
        })
        .catch(() => {
          thisCtrl.venue.googleMapImageUrl = '';
        });
    }

    const initVenueBlog = {};
    function loadVenueBlogContent(venueId) {
      const isProd = ENV === 'prod';
      if (!initVenueBlog[venueId]) {
        initVenueBlog[venueId] = true;
        updateVenueBlogThunk(venueId, isProd);
      }
    }

    function loadResyConfig(venueId) {
      getResyConfigVenueThunk(venueId)
        .then((config) => {
          if (!config) {
            return;
          }
          thisCtrl.cc_required = config?.venue?.config?.allow_bypass_payment_method !== 1;
          if (config?.large_party?.message) {
            thisCtrl.isLargePartyConfigured = true;
            thisCtrl.largePartyMessage = config.large_party.message;
          }
          const params = {
            isLargePartyConfigured: thisCtrl.isLargePartyConfigured,
            max: config.venue.max_party_size,
            min: config.venue.min_party_size,
          };
          dispatch(setSelectedCoreSeatsMinMax(params));
          defer(() => $scope.$apply());
        })
        .catch(() => Logger.error('[CATCH] Venue Details Controller: getResyConfigVenueThunk'));
    }

    function loadVenueInventory(venueId, selectedQuantity, forcedReload = false) {
      const params = {
        venue_id: venueId,
        num_seats: selectedQuantity,
        start_date: moment().format(ISO_DATE_FORMAT),
        end_date: moment().add(1, 'year').format(ISO_DATE_FORMAT),
      };
      getVenueInventoryThunk({ params, forcedReload });
    }

    function assessVenueInventory(venueInventory) {
      if ('scheduled' in venueInventory && venueInventory.scheduled.length > 0) {
        thisCtrl.isVenueClosed = false;
        const scheduledWithStates = venueInventory.scheduled.map((item) => {
          const state = CalendarStateDeterminer.determine(
            item.inventory.reservation,
            item.inventory.event
          );
          return { ...item, state };
        });
        const venueInventoryWithStates = { scheduled: scheduledWithStates, last_calendar_day: venueInventory.last_calendar_day };
        thisCtrl.venueInventory = venueInventoryWithStates;
        lastAvailableDate = venueInventoryWithStates.last_calendar_day;
        thisCtrl.nextAvailableDate = venueInventoryUtils.findNextAvailable(venueInventory.scheduled);
        thisCtrl.nextAvailableDateFormatted = moment(thisCtrl.nextAvailableDate).calendar();
      } else {
        thisCtrl.isVenueClosed = true;
        thisCtrl.venueInventory = {};
      }
    }

    async function loadReservations(venueId, selectedDate, selectedQuantity) {
      if (selectedQuantity > thisCtrl.maxQuantity) {
        thisCtrl.reservations = [];
      } else {
        thisCtrl.reservations = null;
        const params = {
          venue_id: venueId,
          day: moment(selectedDate).format(ISO_DATE_FORMAT),
          party_size: selectedQuantity,
          time_filter: thisCtrl.selectedTime === ALL_DAY ? undefined : moment(thisCtrl.selectedTime, 'HHmm').format('HH:mm'),
          service_day_cutoff: thisCtrl.filterQuery?.service_day_cutoff,
        };
        await getVenueReservationsThunk({ params });
      }
    }

    thisCtrl.loadReservations = loadReservations;

    function clearTimeFilter() {
      // removes the time filter and triggers a new fetch for reservation data
      dispatch(setSelectedCoreTime(undefined));
    }

    /*
    * Transform array of image urls into objects with id and url props.
    * This makes ngRepeat treat each as unique to alleviate duplicate images breaking the carousel.
    */
    function processImages(responsiveImages, images) {
      const {
        aspect_ratios: aspectRatios,
        file_names: files,
        urls,
      } = responsiveImages;

      let idealAspectRatio;

      if (aspectRatios['1:1']) {
        idealAspectRatio = '1:1';
      } else if (aspectRatios['4:3']) {
        idealAspectRatio = '4:3';
      } else if (aspectRatios['16:9']) {
        idealAspectRatio = '16:9';
      } else {
        Logger.error('venue images is missing aspect ratios ', responsiveImages);

        // responsive images payload doesn't adhere to expected shape
        // revert to using whatever images are available
        return images.map((image, i) => ({
          id: i,
          url: image,
        }));
      }

      return files.map((fileSlug) => {
        const availableDimensions = Object.keys(urls[fileSlug][idealAspectRatio]);
        const availableDimensionInts = availableDimensions.map((dimension) => parseInt(dimension, 10));
        const largestImageSize = Math.max(...availableDimensionInts);
        const chosenImage = urls[fileSlug][idealAspectRatio][largestImageSize];

        return {
          id: fileSlug,
          url: chosenImage,
        };
      });
    }

    async function fetchUpcomingEvents(venueId) {
      try {
        const response = await getEventsUpcoming({ venue_id: venueId });
        thisCtrl.upcomingEvents = response?.events;
        defer(() => $scope.$apply());
      } catch (err) {
        Logger.error(`[VenuePage] error fetching upcoming events: ${err}`);
      }
    }

    function buildRestaurantSchema() {
      restaurantSchema = utils.schema(
        thisCtrl.venue,
        'Restaurant'
      );
      thisCtrl.restaurantSchema = sanitizeString(JSON.stringify(restaurantSchema));
    }

    function buildWidgetConfig() {
      const queryParams = $location.search();
      globalWidgetConfig.venueId = thisCtrl.venue.id;
      globalWidgetConfig.src = 'resy.com-venue-details';

      if (queryParams.reservation === 'true') {
        globalWidgetConfig.reservation = true;
      }
      if (checkIfType.isString(queryParams.date)) {
        globalWidgetConfig.date = queryParams.date;
      }
      if (checkIfType.isString(queryParams.seats)) {
        globalWidgetConfig.seats = queryParams.seats;
      }
      if (checkIfType.isString(queryParams.num_seats)) {
        globalWidgetConfig.seats = queryParams.num_seats;
      }
      if (checkIfType.isString(queryParams.party_size)) {
        globalWidgetConfig.seats = queryParams.party_size;
      }
      if (checkIfType.isString(queryParams.resyToken)) {
        globalWidgetConfig.resyToken = queryParams.resyToken;
      }
      if (checkIfType.isString(queryParams.aff_id)) {
        globalWidgetConfig.affId = queryParams.aff_id;
      }

      // google availability feed
      if (checkIfType.isString(queryParams.first_name)) {
        globalWidgetConfig.firstName = queryParams.first_name;
      }
      if (checkIfType.isString(queryParams.last_name)) {
        globalWidgetConfig.lastName = queryParams.last_name;
      }
      if (checkIfType.isString(queryParams.email_address)) {
        globalWidgetConfig.email = queryParams.email_address;
      }
      if (checkIfType.isString(queryParams.mobile_number)) {
        globalWidgetConfig.phone = queryParams.mobile_number;
      }
      if (checkIfType.isString(queryParams.reservation_date_time)) {
        // expecting ISO 8601 format in venue's local time
        // example: 1994-11-05T08:15:30-05:00
        globalWidgetConfig.date = queryParams.reservation_date_time.slice(0, 10);
        globalWidgetConfig.timeslot = queryParams.reservation_date_time.slice(11, 19);
      }

      // situations that need to launch the widget right away
      // link to user reservations
      // link to a table config (e.g. from notify)
      if ('reservation' in globalWidgetConfig) {
        /**
         * Clubhouse: 14225
         * The Manage/Change Reservation link from emails contains both the `reservation` and `resyToken` params.
         * The widget is built to load and go directly to Change/Cancel if
         * it is opened with the `resyToken` being present in the config and `reservation` not being present.
         * So we can support this by simply deleting the `reservation` property before opening.
         */
        if ('resyToken' in globalWidgetConfig) {
          delete globalWidgetConfig.reservation;
        }
        resyWidget.openModal(globalWidgetConfig);
      }

      // Resets
      $location.search('reservation', null).replace();
      delete globalWidgetConfig.reservation;
    }

    function buildPageTitle(venueName) {
      $scope.metadata.title = getTranslation({
        translationKey: 'titles.venue_details',
        translationValues: { venueName },
        fallback: `Book Your ${venueName} Reservation Now on Resy`,
      });
    }

    function resetReservationsData() {
      thisCtrl.reservations = [];
      thisCtrl.notifyForUnavailable = null;
      thisCtrl.activeNotifications = {};
    }

    function onTimeChange({ time }) {
      const previousTime = thisCtrl.selectedTime;
      if (previousTime !== time) {
        dispatch(setSelectedCoreTime(time));
        defer(() => $scope.$apply());
      }
    }

    function showAuthModal(successCallback) {
      $rootScope.$broadcast('MODAL', 'signin', { successCallback });
    }

    function buildPrice(num, currency) {
      let price = '';
      const symbol = currency || '$';

      for (let i = 0; i < num; i += 1) {
        price += symbol;
      }

      return price;
    }
  }
})();

export default () => { };
